export enum VIDEO_PREVIEW_FLAG {
  IDLE = "idle",
  INPROGRESS = "in_progress",
  DONE_PREVIEW = "done_preview",
  DONE_DOWNLOAD = "done_download",
  ERROR = "error",
  ABORT = "abort",
  MANUAL_ABORT = "manual_abort",
}
